












































































import Vue from "vue";
import Component from "vue-class-component";

import { MemberManagerService as memberApi } from "@/common/api/services/MemberManagerService";
import { formatImageUrl } from "@/common/utils";
import qNotify from "@/common/qNotify";
import { MeService as meApi } from "@/common/api";
import { namespace } from "vuex-class";

const auth = namespace("MemberAuth");
@Component({
  name: "AlbumDetail",
  components: {},
})
export default class AlbumDetail extends Vue {
  @auth.Getter
  getLoggingUser;

  album: any = {
    title: "",
  };
  showImage = false;
  currentImage = null;
  currentImageKey = 0;

  params: any = {
    id: null,
    groupId: null,
  };

  isLikeAlbum = false;

  mounted() {
    this.params = this.$router.currentRoute.params;
    this.getDetail();

    if (this.getLoggingUser) {
      this.setIsLikeAlbum();
    }
  }

  async getDetail() {
    try {
      const result = await memberApi.memberAlbumShow(this.params);

      this.album = result.data.album;
    } catch (error) {
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  getImagePath(image, size = "400x400") {
    return image
      ? formatImageUrl(image.name, size)
      : formatImageUrl("not-found.jpg", size);
  }

  showImagePopup(image, imageKey) {
    this.currentImage = image;
    this.currentImageKey = imageKey;
    this.showImage = true;
  }

  next(step) {
    let index = this.album.images.indexOf(this.currentImage);
    if (step < 0 && index == 0) {
      index = this.album.images.length;
    }
    this.currentImageKey += step;
    this.currentImage = this.album.images[index + step] || this.album.images[0];
  }

  async like() {
    try {
      await meApi.meLikeAlbum({ albumId: this.album.id });
      this.isLikeAlbum = !this.isLikeAlbum;
      this.album.totalLike += this.isLikeAlbum ? 1 : -1;
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
    }
  }

  async setIsLikeAlbum() {
    try {
      const result = await meApi.meIsLikeAlbum({ albumId: this.params.id });
      this.isLikeAlbum = result.data.isLikeAlbum;
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
    }
  }
}
